const state = {
  device: {
    lang: 'zh-cn',
    udid: 'test',
    platform: '1',
    platformType: '0'
  }
}

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, {})
  },
  SET_DEVICE_DATA: (state, data) => {
    for (const key in data) {
      state.device[key] = data[key]
    }
  }
}

const actions = {
  // user login
  setDeviceData ({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit('SET_DEVICE_DATA', data)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/device.js